import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getDominantSpeakerParticipant, getParticipantDisplayName, isScreenShareParticipant } from '../../../base/participants/functions';
import { SPEAKING_INDICATOR_BORDER_RADIUS } from '../../../meeting-ui/constants';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            backgroundColor: theme.palette.speakingIndicatorBackground,
            borderRadius: SPEAKING_INDICATOR_BORDER_RADIUS,
            color: theme.palette.speakingIndicatorText,
            fontSize: '0.875rem',
            left: '50%',
            lineHeight: '1.25rem',
            padding: '6px 16px',
            pointerEvents: 'none',
            position: 'absolute',
            top: 56,
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            zIndex: 250,
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)'
        }
    };
});
/**
 * 主舞台顶部发言指示器 — 显示当前正在讲话的参与者姓名。
 *
 * Hooks 必须在任何条件 return 之前全部调用，否则在「无主讲人 → 有主讲人」
 * （例如对端开麦成为 dominant speaker）时会触发 React #310 并导致 BaseApp 崩溃闪退。
 *
 * @returns {ReactElement|null}
 */
const SpeakingIndicator = () => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const dominantSpeaker = useSelector((state) => getDominantSpeakerParticipant(state));
    const speakerId = dominantSpeaker && !isScreenShareParticipant(dominantSpeaker)
        ? dominantSpeaker.id
        : undefined;
    const displayName = useSelector((state) => (speakerId ? getParticipantDisplayName(state, speakerId) : ''));
    if (!speakerId || !displayName) {
        return null;
    }
    return (React.createElement("div", { "aria-live": 'polite', className: classes.container }, t('speakerIndicator.speaking', { name: displayName })));
};
export default SpeakingIndicator;
